import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en, el, de, DEFAULT_LANGUAGE } from '@wooconnect/i18n';

const savedLang = localStorage.getItem('wca_language') ?? DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    el: { translation: el },
    de: { translation: de },
  },
  lng: savedLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
